import React, { Component } from "react";
import {
    NavBar,
    Icon,
    List,
    Button,
    WhiteSpace,
    WingBlank,
    InputItem,
    Toast,
    Picker,
} from "antd-mobile";
import axios from "../../../service/axios";
import { createForm } from "rc-form";
import { connect } from "dva";
const Item = List.Item;
const loginAdminMsg =
    sessionStorage.getItem("loginMsg") &&
    JSON.parse(sessionStorage.getItem("loginMsg"));

const currencyType = [
    {
        label: "虚拟币",
        value: 1,
    },
    {
        label: "终身币",
        value: 4,
    },
    {
        label: "行业币",
        value: 3,
    },
    {
        label: "续费币",
        value: 2,
    },
];
if (loginAdminMsg && (loginAdminMsg.userType != 3 || loginAdminMsg.preferentialMonths <= 0)) {
    currencyType.pop();
}
@connect(({ app, admin }) => ({ app, admin }))
export class AdminNum extends Component {
    state = {
        adminUser: {},
        baseAvailInfo: {},
        loginAdminMsg: {},
        type: 0,
        defaultCurrencyType: 1,
        highTradeSurlpusCount: 0,
        lowTradeSurlpusCount: 0,
    };
    componentDidMount() {
        // this.props.dispatch({
        //     type: "app/getCurrencyCountOfAdmin",
        //     payload: Array.of(loginAdminMsg.id),
        // });
        //延时1s，防止后台接口操作太频繁
        // setTimeout(() => {
        //     this.props.dispatch({
        //         type: "admin/getCurrencyCount",
        //         payload: Array.of(this.props.match.params.id),
        //     });
        // }, 1000);
        const { dispatch } = this.props;
        console.log('his.props.match.params',this.props.match.params)
        // 查询终身币
        dispatch({
            type: 'app/getPermanentCount',
            payload: {type: 4} 
        })
        //查询目标终身币
        dispatch({
            type: 'app/getPermanentCountById',
            payload: {type: 4,adminId: this.props.match.params.id}
        })
        // 查询 续费币
        dispatch({
            type: "app/getCurrencyRenewSurlpusCount",
            payload: { adminId: this.props.match.params.id },
        });
        // 查询 行业币
        dispatch({
            type: "app/getCurrencyTradeSurlpusCount",
            payload: { adminId: loginAdminMsg.id },
        }).then(res => {
            this.setState({
                highTradeSurlpusCount: res || 0,
            });
        });
        setTimeout(() => {
            dispatch({
                type: "app/getCurrencyTradeSurlpusCount",
                payload: { adminId: this.props.match.params.id },
            }).then(res => {
                this.setState({
                    lowTradeSurlpusCount: res || 0,
                });
            });
        }, 800);
    }

    validateOptNumber = (rule, value, callback) => {
        let typeName = this.props.match.params.type == 0 ? "下发" : "回收";
        if (value) {
            if (value < 1) {
                callback(new Error("请填写大于0的数字"));
            } else {
                callback();
            }
        } else {
            callback(new Error(`请填写${typeName}的额度值`));
        }
    };
    onTypeChange = e => {
        console.log(e);
        this.setState({
            type: e[0],
        });
    };
    render() {
        const { getFieldProps, getFieldError } = this.props.form;
        const { match, app, admin, dispatch } = this.props;
        const { currencyTotalCount, currencyUsedCount, renewSurlpusCount,permanentCurrencyCount,permanentCurrencyCount2 } = app;
        const { adminCurrencyCount } = admin;
        let typeName = this.props.match.params.type == 0 ? "下发" : "回收";
        const submitBtn = () => {
            this.props.form.validateFields({ force: true }, error => {
                if (!error) {
                    let actionType = this.props.match.params.type == 0 ? "adminCurrencyGrant" : "adminCurrencyRetrieve";
                    console.log(this.props.form.getFieldsValue());
                    const { number } = this.props.form.getFieldsValue();
                    const { type } = this.props.form.getFieldsValue();
                    let payload = {
                        count: number,
                        targetId: this.props.match.params.id,
                        type: type ? type[0] : 1,
                    };
                    dispatch({
                        type: `admin/${actionType}`,
                        payload,
                    });
                }
            });
        };
        return (
            <div>
                <div className="addAdmin">
                    <div className="header-sticky header-navbar">
                        <NavBar
                            icon={<Icon type="left" />}
                            onLeftClick={() => this.props.history.goBack()}
                        >
                            {typeName}币
                        </NavBar>
                    </div>
                    <div className="sub-container">
                        <List
                            renderHeader={`当前登录管理员${loginAdminMsg.loginName}总额度`}
                        >
                            <Item extra={currencyTotalCount}>总虚拟币数</Item>
                            <Item extra={currencyUsedCount}>已用虚拟币数</Item>
                            <Item
                                extra={currencyTotalCount - currencyUsedCount}
                            >
                                可用虚拟币数
                            </Item>
                            <Item extra={permanentCurrencyCount}>
                                可用终身币数
                            </Item>
                            <Item
                                extra={this.state.highTradeSurlpusCount}
                            >
                                可用行业币数
                            </Item>
                        </List>
                        <List
                            renderHeader={`管理员${match.params.name}可用额度`}
                        >
                            <Item extra={adminCurrencyCount.totalCount}>
                                总虚拟币数{" "}
                            </Item>
                            <Item extra={adminCurrencyCount.usedCount}>
                                已用虚拟币数{" "}
                            </Item>
                            <Item extra={adminCurrencyCount.surplusCount}>
                                可用虚拟币数{" "}
                            </Item>
                            <Item extra={permanentCurrencyCount2}>
                                可用终身币数{" "}
                            </Item>
                            <Item extra={this.state.lowTradeSurlpusCount}>
                                可用行业币数{" "}
                            </Item>
                            {(loginAdminMsg && loginAdminMsg.userType == 3 && loginAdminMsg.preferentialMonths > 0) ? (
                                <Item extra={renewSurlpusCount}>
                                    可用续费币数{" "}
                                </Item>
                            ) : ("")}
                        </List>
                        {/* {(loginAdminMsg && loginAdminMsg.userType == 3 && loginAdminMsg.preferentialMonths > 0) ? ( */}
                        <List
                            renderHeader={`币种类型`}
                        >
                            <Picker
                                data={currencyType}
                                cols={1}
                                onChange={this.onChangeColor}
                                {...getFieldProps("type", {
                                    rules: [{ required: true, message: "请选择币种类型" }],
                                    initialValue: [this.state.defaultCurrencyType],
                                })}
                            >
                                <List.Item arrow="horizontal">币种类型 </List.Item>
                            </Picker>
                        </List>
                        <List
                            renderHeader={typeName + "数量"}
                            renderFooter={() => getFieldError("number")}
                        >
                            <InputItem
                                {...getFieldProps("number", {
                                    rules: [
                                        { validator: this.validateOptNumber },
                                    ],
                                })}
                                clear
                                type="number"
                                placeholder={`请填写${typeName}数量`}
                            >
                                {typeName}数量
                            </InputItem>
                        </List>
                        <WhiteSpace size="xl" />
                        <WingBlank>
                            <Button type="primary" onClick={() => submitBtn()}>
                                确定
                            </Button>
                            <WhiteSpace size="xl" />
                            <Button onClick={() => this.props.history.goBack()}>
                                返回
                            </Button>
                        </WingBlank>
                    </div>
                </div>
            </div>
        );
    }
}
export default createForm()(AdminNum);
